import React, { useEffect, useContext } from "react";
import SbEditable from "storyblok-react";
import Components from "../components";
import { PageContext } from "@/context/PageContext";
import Main from "@/components/Layout/main";
import { anyToKebab } from "../../helpers/utils";
import Breadcrumbs from "../Breadcrumbs/breadcrumbs";
import { ProtectedPageStoryblok } from "@/types/component-types-sb";

const ProtectedPage = (props: ProtectedPageStoryblok) => {
  const { content, name } = props;

  const { data, setData } = useContext(PageContext);

  useEffect(() => {
    setData({
      ...data,
      page_class: anyToKebab(name),
    });
    return () => setData({ ...data, footer_bg_color: "" });
  }, [content, name]);

  return (
    // @ts-expect-error
    <SbEditable content={props.content}>
      <Main className="pro-cycling-page">
        <Breadcrumbs />
        {content?.body?.map((blok: any) => {
          return React.createElement(Components(blok.component), {
            key: blok._uid,
            blok,
          });
        })}
      </Main>
    </SbEditable>
  );
};

export default ProtectedPage;
